import { AxiosResponse } from 'axios';
import { DownloadHistoryListResponse, DownloadHistoryModel } from 'types/entity';
import { http } from './settings';

export const fetchDownloadHistories = (projectId: string): Promise<DownloadHistoryModel[]> => http
  .get(`/projects/${projectId}/download-history/search`)
  .then((value: AxiosResponse<DownloadHistoryListResponse>) => value.data.api_display_values || []);
